import esContent from './gatorProtect.es';

export default {
  ...esContent,
};
